// extracted by mini-css-extract-plugin
export default {"tableRowLight":"Table_tableRowLight__RrRks","tableRowDark":"Table_tableRowDark__YmC++"};